const HelpCenter = [
  {
    id: 1,
    title: 'Knowledge base',
    description:
      "Get answers to ProxyScrape's most commonly asked questions in the Knowledge base.",
    link: 'https://support.proxyscrape.com/',
    linkTitle: 'Visit Knowledge Base',
    img: require('../assets/img/svg/faq.svg'),
  },
  {
    id: 2,
    title: 'Contact',
    description: "Didn't find the answer to your question in the F.A.Q? Contact us via email here.",
    link: 'https://proxyscrape.com/contact',
    linkTitle: 'Contact Us',
    img: require('../assets/img/svg/contact.svg'),
  },
  {
    id: 3,
    title: 'Roadmap',
    description:
      'Help ProxyScrape improve by voting for the best feature request, or make your own.',
    link: 'https://roadmap.proxyscrape.com/',
    linkTitle: 'Open Roadmap',
    img: require('../assets/img/svg/roadmap.svg'),
  },
];

export default HelpCenter;
